import React from 'react';
import '../../styles/home.css'; // Import CSS file for home styling



import images from "../../pages/Home/images";
import ImageSlider from './../Home/ImageSlider';

import Packages from "../Packages";
import About from "../About";
import Contact from "../Contact";


const Home = () => {
    return (
        <div >
            <ImageSlider images={images} />
            <Packages/>
            {/* <About/> */}
            <Contact/>
        </div>
    );
};

export default Home;
